import { motion } from 'framer-motion'
import { useState } from 'react'

const contactInfo = {
  phone: '17302483733',
  wechat: 'wanglaoshi_baking',
  email: '40384081@qq.com',
  address: '辽宁省沈阳市大东区滂江街22号龙之梦购物中心',
  hours: '周一至周日 9:00-21:00',
}

const courses = [
  '法式马卡龙专修课',
  '欧式面包综合课',
  '创意裱花课程',
  '精品甜品大师班',
  '翻糖艺术专业课',
  '咖啡轻食综合课',
]

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    wechat: '',
    course: '',
    message: '',
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    // Simulate form submission
    await new Promise((resolve) => setTimeout(resolve, 1500))
    setIsSubmitting(false)
    setSubmitted(true)
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  return (
    <div className="grain-overlay">
      {/* Hero */}
      <section className="relative py-20 bg-gradient-to-br from-cream via-cream to-champagne/10">
        <div className="absolute bottom-10 left-20 w-64 h-64 bg-caramel/10 rounded-full blur-3xl" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <h1 className="font-display text-5xl text-chocolate mb-6">联系我们</h1>
            <p className="text-lg text-chocolate/60 max-w-2xl mx-auto">
              准备好开始您的烘焙之旅了吗？填写下方表单，我们的课程顾问将在24小时内与您联系
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="bg-cream rounded-3xl p-8 shadow-lg"
            >
              {submitted ? (
                <div className="text-center py-12">
                  <div className="text-7xl mb-6">🎉</div>
                  <h3 className="font-display text-2xl text-chocolate mb-4">提交成功！</h3>
                  <p className="text-chocolate/60 mb-6">
                    感谢您的咨询，我们的课程顾问将在24小时内与您联系。
                  </p>
                  <button
                    onClick={() => setSubmitted(false)}
                    className="text-caramel hover:text-champagne font-medium"
                  >
                    再次提交
                  </button>
                </div>
              ) : (
                <>
                  <h2 className="font-display text-2xl text-chocolate mb-6">预约咨询</h2>
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                      <label className="block text-chocolate font-medium mb-2">您的姓名 *</label>
                      <input
                        type="text"
                        name="name"
                        required
                        value={formData.name}
                        onChange={handleChange}
                        className="w-full px-4 py-3 rounded-lg border border-caramel/20 focus:border-caramel focus:outline-none focus:ring-2 focus:ring-caramel/20 transition-all"
                        placeholder="请输入您的姓名"
                      />
                    </div>

                    <div>
                      <label className="block text-chocolate font-medium mb-2">手机号码 *</label>
                      <input
                        type="tel"
                        name="phone"
                        required
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full px-4 py-3 rounded-lg border border-caramel/20 focus:border-caramel focus:outline-none focus:ring-2 focus:ring-caramel/20 transition-all"
                        placeholder="请输入您的手机号码"
                      />
                    </div>

                    <div>
                      <label className="block text-chocolate font-medium mb-2">微信号 (可选)</label>
                      <input
                        type="text"
                        name="wechat"
                        value={formData.wechat}
                        onChange={handleChange}
                        className="w-full px-4 py-3 rounded-lg border border-caramel/20 focus:border-caramel focus:outline-none focus:ring-2 focus:ring-caramel/20 transition-all"
                        placeholder="方便我们更快捷地联系您"
                      />
                    </div>

                    <div>
                      <label className="block text-chocolate font-medium mb-2">感兴趣的课程</label>
                      <select
                        name="course"
                        value={formData.course}
                        onChange={handleChange}
                        className="w-full px-4 py-3 rounded-lg border border-caramel/20 focus:border-caramel focus:outline-none focus:ring-2 focus:ring-caramel/20 transition-all"
                      >
                        <option value="">请选择课程</option>
                        {courses.map((course) => (
                          <option key={course} value={course}>
                            {course}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-chocolate font-medium mb-2">留言 (可选)</label>
                      <textarea
                        name="message"
                        rows={4}
                        value={formData.message}
                        onChange={handleChange}
                        className="w-full px-4 py-3 rounded-lg border border-caramel/20 focus:border-caramel focus:outline-none focus:ring-2 focus:ring-caramel/20 transition-all resize-none"
                        placeholder="您有什么想了解的？"
                      />
                    </div>

                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full btn-primary text-lg py-4 disabled:opacity-70 disabled:cursor-not-allowed"
                    >
                      {isSubmitting ? (
                        <span className="flex items-center justify-center gap-2">
                          <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                          </svg>
                          提交中...
                        </span>
                      ) : (
                        '提交咨询'
                      )}
                    </button>
                  </form>
                </>
              )}
            </motion.div>

            {/* Contact Info */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="space-y-8"
            >
              {/* Info Cards */}
              <div className="bg-cream rounded-2xl p-6 card-hover">
                <h3 className="font-display text-xl text-chocolate mb-4">联系方式</h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-caramel/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-2xl">📞</span>
                    </div>
                    <div>
                      <p className="text-sm text-chocolate/60">电话</p>
                      <p className="text-chocolate font-medium">{contactInfo.phone}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-caramel/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-2xl">💬</span>
                    </div>
                    <div>
                      <p className="text-sm text-chocolate/60">微信</p>
                      <p className="text-chocolate font-medium">{contactInfo.wechat}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-caramel/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-2xl">✉️</span>
                    </div>
                    <div>
                      <p className="text-sm text-chocolate/60">邮箱</p>
                      <p className="text-chocolate font-medium">{contactInfo.email}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-cream rounded-2xl p-6 card-hover">
                <h3 className="font-display text-xl text-chocolate mb-4">上课地址</h3>
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-12 h-12 bg-caramel/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-2xl">📍</span>
                  </div>
                  <div>
                    <p className="text-chocolate">{contactInfo.address}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-caramel/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-2xl">🕐</span>
                  </div>
                  <div>
                    <p className="text-chocolate">{contactInfo.hours}</p>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="bg-gradient-to-br from-caramel/20 to-champagne/20 rounded-2xl aspect-video flex items-center justify-center">
                <div className="text-center">
                  <span className="text-6xl mb-4 block">🗺️</span>
                  <p className="text-chocolate/60">地图展示区域</p>
                  <p className="text-sm text-chocolate/40">辽宁省沈阳市大东区滂江街22号龙之梦购物中心</p>
                </div>
              </div>

              {/* WeChat QR */}
              <div className="bg-cream rounded-2xl p-6 text-center">
                <span className="text-6xl mb-4 block">📱</span>
                <h3 className="font-display text-lg text-chocolate mb-2">扫码添加微信</h3>
                <p className="text-sm text-chocolate/60">备注"烘焙课程"更快通过</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 bg-cream">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="font-display text-3xl text-chocolate mb-4">常见问题</h2>
            <p className="text-chocolate/60">您可能想了解的问题</p>
          </motion.div>

          <div className="space-y-4">
            {[
              { q: '我没有烘焙基础，能学会吗？', a: '当然可以！我们的课程针对零基础学员设计，采用小班教学模式，老师会手把手指导。' },
              { q: '课程学费包含材料费吗？', a: '是的，学费包含全部材料费用，学员无需额外购买任何材料。' },
              { q: '学完后能获得证书吗？', a: '完成课程后，您将获得由我们颁发的结业证书，也可协助报考国家认可的烘焙师资格证。' },
              { q: '可以分期付款吗？', a: '我们支持分期付款，具体方案可咨询课程顾问。' },
            ].map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white rounded-xl p-6 shadow-sm"
              >
                <h4 className="font-medium text-chocolate mb-2">Q: {faq.q}</h4>
                <p className="text-chocolate/60 text-sm">{faq.a}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}